<template>
  <div class="content new-profile">
    <div class="md-layout" @click="selectArea($event)">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 "
      >
        <h1
          v-if="this.$route.name === 'NewProfile'"
          class="ml-3 section_header mt-0"
        >
          Industry Financial Profile
          <try-beta-pill :product="$route.query['data-id'] ? 'financial_report' : 'ifp'" />
        </h1>
        <profile-steps />
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mb-4"
      >
        <div class="md-layout md-gutter md-alignment-center-center">
          <div class="searchResultWpr">
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-left-sec"
            >
              <span class="md-title profile-title">
                Industry Financial Profile
                <try-beta-pill v-if="dataId" product="financial_report" :data-id="dataId" />
              </span>
              <div>
                <p v-if="this.$route.name === 'NewProfile'" class="description">
                  Our flagship product provides financial data for over 5,000
                  industry segments in over 350 areas with up to 15 sales class
                  options. It includes 24 lines of income statement data, 16
                  lines of balance sheet data, and 36 financial ratios, with
                  historical data as far back as 2001.
                </p>

                <p v-else class="description">
                  Combine our financial data with your inputs for instant
                  insight into company performance. Results include scores for
                  profitability, efficiency, cash flow, and debt risk, variance
                  tables, comparative charts, and ratio analysis. Further
                  customize results and manage inputs from within the report.
                </p>

                <ul class="profile_details">
                  <li v-if="$store.getters.industry">
                    <div>

                      <p v-if="$store.getters.industry_params != null && $store.getters.industry_params.selector_message != ''"
                       class="h6-p" style="font-weight: bold; color: orange;">
                       <i class="fa fa-exclamation-triangle"></i>
                       {{ $store.getters.industry_params.selector_message }} Please click <a href="https://www.bls.gov/respondents/ars/2022-naics.htm" target="_blank">HERE</a> to learn more.
                       <br><br>
                       For more information, please visit <a href="https://support.bizminer.com/article/228-2022-naics-update" target="_blank">this page</a>.
                      </p>

                      
                      <p class="h3-p">{{ $store.getters.industry }}</p>
                      <p class="h6-p">Industry</p>
                    </div>
                  </li>
                  <li v-if="$store.getters.marketArea">
                    <div>
                      <p class="h3-p">
                        {{ $store.getters.marketArea.split("[")[0] }}
                      </p>
                      <p class="h6-p">Market Area</p>
                    </div>
                  </li>
                  <li v-if="$store.getters.salesClass">
                    <div>
                      <p class="h3-p">
                        {{ $store.getters.salesClass.split("[")[0] }}
                      </p>
                      <p class="h6-p">Sales Class</p>
                    </div>
                  </li>
                  <li v-if="$store.getters.years">
                    <div>
                      <p class="h3-p">
                        {{ $store.getters.years }} Years Profile
                      </p>
                      <p class="h6-p">Time Series</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-right-sec"
            >
              <PulseLoader
                :loading="loading"
                :class="{ hide: !loading }"
                quote="Action is the foundational key to all success"
                author="Pablo Picasso"
                profession="Spanish Painter"
                img="picasso.jpg"
                logo="loading"
              ></PulseLoader>
              <div class="md-layout">
                <div
                  class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 fin-pro-card no_padding"
                >
                  <profile-card class="toolbar-card">
                    <template slot="header">
                      <div class="toolbar-card-title">
                        <p class="title text-left">Firms Analyzed</p>
                      </div>
                    </template>
                    <template slot="content">
                      <div class="info-wrap">{{ firmsAnalyzed }}</div>
                    </template>
                  </profile-card>
                </div>
                <div
                  class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 no_padding"
                >
                  <profile-card class="toolbar-card">
                    <template slot="header">
                      <div class="toolbar-card-title">
                        <p class="title text-left">
                          Most Recent Report Year Revenue
                        </p>
                      </div>
                    </template>
                    <template slot="content">
                      <div class="info-wrap">{{ endYearAverage }}</div>
                    </template>
                  </profile-card>
                </div>
                <div
                  v-if="productPrice && !isAccessible"
                  class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
                >
                  <div class="md-layout-item mt-10">
                    <div class="product-price-label">
                      <h3 class="title text-center">
                        Price:
                        <span class="product-price">${{ productPrice }}</span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div
                  class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
                >
                  <template>
                    <div v-if="isAccessible">
                      <md-button
                        @click.native="confirmationModal = true"
                        :disabled="isDisabled || submitting"
                        class="md-info md-block access-button"
                      >
                        <span>Access Now</span>
                      </md-button>
                    </div>
                    <div v-else>
                      <md-button
                        @click.native="access"
                        :disabled="isDisabled || submitting"
                        class="md-info md-block access-button"
                      >
                        <span>{{ submitting ? "Processing..." : "Add To Cart" }}</span>
                      </md-button>
                    </div>
                  </template>
                  <div class="alert md-layout-item" v-if="notAvailable">
                    <span class="closebtn" @click="closeAlert">&times;</span>
                    Sorry, we do not have enough data available for this
                    selection. Please try again.
                  </div>
                  <div class="alert md-layout-item" v-if="fiveYearUnavailable">
                    <span class="closebtn" @click="closeAlert">&times;</span>
                    The 5-year profile is not available for this selection — the earlier
                    years do not have enough reporting firms. The 3-year profile is
                    available: change Years to 3 to continue.
                  </div>
                  <div class="alert md-layout-item" v-if="notOffered">
                    <span class="closebtn" @click="closeAlert">&times;</span>
                    Sorry, we do not offer industry financial products with
                    these parameters. Please choose a more detailed
                    industry/sales class.
                  </div>
                </div>
                <div
                  v-if="profileType != 'Sole proprietorship'"
                  class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 align-div-components"
                >
                  <md-checkbox
                    v-if="isProfile && isShowChecked && isAccessible"
                    v-model="accessLegacyIsChecked"
                  >
                    {{ textLegacyAccess }}</md-checkbox
                  >
                  <md-checkbox
                    v-else-if="isProfile && isShowChecked && !isAccessible"
                    v-model="accessLegacyIsChecked"
                  >
                    {{ textLegacyAccessPrice }}</md-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prospect_content">
      <modal v-if="confirmationModal" @close="confirmationModal = false">
        <template slot="header">
          <button
            type="button"
            class="close_btn"
            @click="confirmationModal = false"
          >
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <div class="field_wpr">
            <h4 class="modal-title">
              Please confirm access to this product with the selected
              parameters. Click Review to review the parameters or Access Now to
              access this product.
            </h4>
            <div class="ml-4 md-layout">
              <md-button
                @click="confirmationModal = false"
                :disabled="submitting"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40"
                >Review</md-button
              >
              <md-button
                @click="access"
                :disabled="submitting"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40"
                >{{ submitting ? "Processing..." : "Access Now" }}</md-button
              >
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal, ProfileCard, PulseLoader } from "@/components";
import ProfileSteps from "./_partials/ProfileSteps.vue";
import TryBetaPill from "./SelectorBeta/TryBetaPill.vue";
import { trackSelectorViewed, trackSelectorCompleted } from "./SelectorBeta/analytics";
import axios from "axios";
import { mapActions, mapState } from "vuex";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  name: "new-profile",
  components: {
    ProfileCard,
    ProfileSteps,
    TryBetaPill,
    PulseLoader,
    Modal,
  },
  data() {
    return {
      isProfile: false,
      route: null,
      confirmationModal: false,
      notAvailable: false,
      notOffered: false,
      fiveYearUnavailable: false,
      worstYearFirms: null,
      minFirmsRule: null,
      type: "",
      isDisabled: true,
      submitting: false,
      firmsAnalyzed: "",
      endYearAverage: "",
      loading: false,
      myData: null,
      years: this.financeData,
      isAccessible: true,
      productPrice: null,
      accessLegacyIsChecked: false,
      isShowChecked: false,
      textLegacyAccess: "",
      textLegacyAccessPrice: "",
    };
  },
  props: ["dataId", "isCSV", "file", "financeData"],

  methods: {
    ...mapActions({
      updatePullTime: "tracking/updatePullTime",
    }),
    selectArea: function(e) {
      let parentDiv = document.querySelectorAll(".custom-step-pro");
      let deactiveClass = document.querySelectorAll(".step-progress__step");
      let favoriteDropdown = document.querySelectorAll(".favourite_list");
      deactiveClass.forEach(function(el) {
        el.classList.remove("open");
      });
      favoriteDropdown.forEach(function(el) {
        el.classList.remove("open");
      });
      parentDiv.forEach(function(el) {
        el.addEventListener("click", function(e) {
          e.stopPropagation();
        });
      });
    },
    closeAlert: function() {
      this.notAvailable = false;
      this.notOffered = false;
      this.fiveYearUnavailable = false;
    },
    getData: function(name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    access: async function() {
      if (this.submitting) return;
      this.submitting = true;
      try {
      if (this.dataId) {
        await this.addInputsForReport(this.profileId);
      } else {
        let params = {
          product_id: this.profileId,
          access_legacy: this.accessLegacyIsChecked,
        };

        let queueUserID = this.$store.getters["user/user_id"];
        if(queueUserID == 372679 || true) {
          localStorage.setItem("queueUserID", queueUserID);
          let currentSession = localStorage.getItem("vue-authenticate.vueauth_access_token");
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + '/queue/load/' + this.profileId, {
              params: {session_id: currentSession},
            })
            .then((res) => {}
          );
        } else {
          localStorage.setItem("queueUserID", null);
        }

        await this.$store.dispatch("cart/accessProduct", params).then((res) => {
          if (res.cart) {
            this.$router.push({
              name: "Cart",
              params: { id: this.profileId },
            });
          }

          if (
            res.access ||
            (res.error && res.errorCode === "product_already_accessed")
          ) {
            this.loaded = true;
            trackSelectorCompleted(this.$route.query["data-id"] ? "financial_report" : "ifp", "classic");
            if (this.profileType === "Sole proprietorship") {
              this.$router.push({
                name: "SPIFAbout",
                params: { id: this.profileId },
              });
            } else {
              this.$router.push({
                name: "IFAbout",
                params: { id: this.profileId },
              });
            }
          }
        });
      }
      } finally {
        this.submitting = false;
      }
    },
    addInputsForReport: async function(profileId) {
      this.loaded = false;
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      let type = this.$store.getters.type === "Industry firms" ? "if" : "spif";
      let data = {};

      if (type === "if") {
        data = {
          accounts_payable_business_revenue_check: true,
          ebitda_business_revenue_check: true,
          current_ratio_check: true,
          return_on_assets_check: true,
          quick_ratio_check: true,
          return_on_net_worth_check: true,
          days_payable_check: true,
          return_on_business_revenue_check: true,
          current_liabilities_inventory_check: true,
          discretionary_owner_earnings_check: true,
          net_working_capital_check: true,
          return_on_assets_after_tax_check: true,
          cosPayables_check: true,
          return_on_net_worth_after_tax_check: true,
          cosInventory_check: true,
          return_on_business_revenue_after_tax_check: true,
          profit_employee_check: true,
          owner_earnings_employee_check: true,
          assets_business_revenue_check: true,
          interest_coverage_check: true,
          days_inventory_check: true,
          current_liabilities_net_worth_check: true,
          days_receivables_check: true,
          long_term_liabilities_net_worth_check: true,
          current_asset_turnover_check: true,
          loans_notes_payable_net_worth_check: true,
          fixed_asset_turnover_check: true,
          zscore_check: true,
          gross_margin_business_revenue_check: true,
          total_liabilities_net_worth_check: true,
          sales_per_employee_check: true,
          fixedAssetsNetWorth_check: true,
          invTurnover_check: true,
          arTurnover_check: true,
          totalAssetTurnover_check: true,
          workingCapitalTurnover_check: true,
          daysWorkingCapital_check: true,
          cashTurnover_check: true,
          efficiency_index_check: true,
          year_0_check: true,
          year_1_check: true,
          year_2_check: true,
          year_3_check: true,
          year_4_check: true,
          year_5_check: true,
          pl_balance_percent_check: true,
          pl_balance_dollar_check: true,
          source_uses_check: true,
          ratio_scores_check: true,
          summary_scores_check: true,
        };
        let i = 0;

        this.years.forEach((year) => {
          if (year.year) {
            data["year_field_" + i] = year.year;
            data["other_netSales_field_" + i] = year.businessRevenue;
            data["cosl_field_" + i] = year.costOfSalesLaborPortion;
            data["other_grossProfit_field_" + i] = year.grossMargin;
            data["other_offcomp_field_" + i] = year.officersComp;
            data["other_payroll_field_" + i] = year.salaryWages;
            data["other_rent_field_" + i] = year.rent;
            data["other_taxes_field_" + i] = year.taxesPaid;
            data["other_advertising_field_" + i] = year.advertising;
            data["other_benefits_field_" + i] = year.benefitsPension;
            data["other_repairs_field_" + i] = year.repairs;
            data["other_baddebt_field_" + i] = year.badDebt;
            data["other_other_field_" + i] = year.salesGeneralAdminMisc;
            data["other_amortization_field_" + i] =
              year.amortizationDepreciationDepletion;
            data["other_interestincome_field_" + i] = year.interestIncome;
            data["other_interest_field_" + i] = year.interestExpense;
            data["other_otherincome_field_" + i] = year.otherIncome;
            data["asset_cash_field_" + i] = year.cash;
            data["asset_accountsReceivable_field_" + i] = year.receivables;
            data["asset_inventory_field_" + i] = year.inventory;
            data["asset_otherCurrent_field_" + i] = year.otherCurrentAssets;
            data["asset_gross_fixed_field_" + i] = year.grossFixedAssets;
            data["asset_depreciation_amortization_depletion_field_" + i] =
              year.accumDepreciationAmortizationDepltn;
            data["asset_fixed_field_" + i] = year.netFixedAssets;
            data["asset_otherNonCurrent_field_" + i] =
              year.otherNonCurrentAssets;
            data["liability_accountsPayable_field_" + i] = year.accountsPayable;
            data["liability_loans_field_" + i] = year.loansNotesPayable;
            data["liability_otherCurrent_field_" + i] =
              year.otherCurrentLiabilities;
            data["liability_longTermDebt_field_" + i] =
              year.totalLongTermLiabilities;
            data["ft_emps_field_" + i] = year.employment;
            data["income_tax_field_" + i] = year.incomeTax;
            data["avg_annual_wage_field_" + i] = year.averageAnnualWage;

            i = i + 1;
          }
        });
      } else {
        data = {
          year_0_check: true,
          year_1_check: true,
          year_2_check: true,
          year_3_check: true,
          net_cash_sales_ratio_check: true,
          sales_net_cash_ratio_check: true,
          gross_profit_sales_ratio_check: true,
          EBITDA_sales_ratio_check: true,
          net_profit_sales_ratio_check: true,
          cost_of_sales_inventory_ratio_check: true,
          days_inventory_check: true,
          EBITDA_interest_check: true,
          sales_inventory_ratio_check: true,
          total_labor_revenue_ratio_check: true,
          profit_per_employee_ratio_check: true,
          owner_earnings_per_employee_ratio_check: true,
          ratio_scores_check: true,
          pl_balance_percent_check: true,
          pl_balance_dollar_check: true,
          summary_score_check: true,
        };
        let i = 0;

        this.years.forEach((year) => {
          if (year.year) {
            data["year_field_" + i] = year.year;
            data["other_netSales_field_" + i] = year.businessRevenue;
            data["cosl_field_" + i] = year.costOfSalesLaborPortion;
            data["other_grossProfit_field_" + i] = year.grossMargin;
            data["other_offcomp_field_" + i] = year.officersComp;
            data["other_payroll_field_" + i] = year.salaryWages;
            data["other_rent_field_" + i] = year.rent;
            data["other_taxes_field_" + i] = year.taxesPaid;
            data["other_advertising_field_" + i] = year.advertising;
            data["other_benefits_field_" + i] = year.benefitsPension;
            data["other_repairs_field_" + i] = year.repairs;
            data["other_baddebt_field_" + i] = year.badDebt;
            data["other_other_field_" + i] = year.salesGeneralAdminMisc;
            data["other_amortization_field_" + i] =
              year.amortizationDepreciationDepletion;
            data["other_interestincome_field_" + i] = year.interestIncome;
            data["other_interest_field_" + i] = year.interestExpense;
            data["other_otherincome_field_" + i] = year.otherIncome;
            data["asset_cash_field_" + i] = year.cash;
            data["asset_accountsReceivable_field_" + i] = year.receivables;
            data["asset_inventory_field_" + i] = year.inventory;
            data["asset_otherCurrent_field_" + i] = year.otherCurrentAssets;
            data["asset_gross_fixed_field_" + i] = year.grossFixedAssets;
            data["asset_depreciation_amortization_depletion_field_" + i] =
              year.accumDepreciationAmortizationDepltn;
            data["asset_fixed_field_" + i] = year.netFixedAssets;
            data["asset_otherNonCurrent_field_" + i] =
              year.otherNonCurrentAssets;
            data["liability_accountsPayable_field_" + i] = year.accountsPayable;
            data["liability_loans_field_" + i] = year.loansNotesPayable;
            data["liability_otherCurrent_field_" + i] =
              year.otherCurrentLiabilities;
            data["liability_longTermDebt_field_" + i] =
              year.totalLongTermLiabilities;
            data["ft_emps_field_" + i] = year.employment;
            data["income_tax_field_" + i] = year.incomeTax;
            data["avg_annual_wage_field_" + i] = year.averageAnnualWage;

            i = i + 1;
          }
        });
      }

      let params = {
        type: type,
        action: "save",
        session_id: currentSession,
        profile_id: this.profileId,
        report_id: this.profileId,
        data: data,
      };

      await this.$store.dispatch("user/saveReport", params).then((res) => {
        this.$store.dispatch("alerts/success", "Inputs applied.");
        params = {
          product_id: this.profileId,
          access_legacy: this.accessLegacyIsChecked,
        };

        this.$store.dispatch("cart/accessProduct", params).then((res) => {
          if (res.cart) {
            this.$router.push({
              name: "Cart",
              params: { id: this.profileId },
            });
          }

          if (
            res.access ||
            (res.error && res.errorCode === "product_already_accessed")
          ) {
            this.loaded = true;
            if (this.dataId) {
              if (this.profileType === "Sole proprietorship") {
                this.$router.push({
                  path: `/sole-proprietorship-finanical-report/${this.profileId}/about-data`,
                });
              } else {
                this.$router.push({
                  path: `/finanical-report/${this.profileId}/about-data`,
                });
              }
            } else {
              if (this.profileType === "Sole proprietorship") {
                this.$router.push({
                  name: "SPIFAbout",
                  params: { id: this.profileId },
                });
              } else {
                this.$router.push({
                  name: "IFAbout",
                  params: { id: this.profileId },
                });
              }
            }
          }
        });
      });
    },
    checkAccess: async function() {
      if (!this.profileId) {
        await this.searchProfile();
      }

      let params = {
        product_id: this.profileId,
      };

      await this.$store
        .dispatch("cart/checkProductAccess", params)
        .then((res) => {
          const { access, ready } = res;
          this.productPrice = res.price;
          this.isAccessible = access;

          if (ready) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
            this.notAvailable = true;
            //this.notOffered = true;
          }
          this.loading = false;
        });
    },
    checkAccessByType: async function() {
      if (this.$route.name === "NewProfile") {
        if (
          this.subscriptions.includes("usif_p") ||
          this.subscriptions.includes("lif_p")
        )
          this.isAccessible = true;
        else this.isAccessible = false;
      } else {
        if (
          this.subscriptions.includes("usif_r") ||
          this.subscriptions.includes("lif_r")
        )
          this.isAccessible = true;
        else this.isAccessible = false;
      }
    },
    async searchProfile() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              area: this.getData(this.marketArea),
              profile_id: this.profileId ? this.profileId : "0",
              type:
                this.$store.getters.type === "Industry firms" ? "if" : "spif",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit("SET_PROFILE_ID", id);
        });
    },
    // The availability answer describes BOTH windows (ok3 / ok5, plus the worst year's
    // firm count in each). The customer picks 3- or 5-year separately, so the chosen one has
    // to be checked here: a 5-year profile whose 2021 or 2022 year has no usable data used to
    // be sold and then rendered empty years. Local (non-US) answers do not carry these keys
    // and keep their previous behaviour.
    applyAvailabilityWindow: function(data) {
      const want5 = String(this.$store.getters.years) === "5";
      const has = (k) => data && data[k] !== undefined && data[k] !== null;
      this.worstYearFirms = want5
        ? (has("min_firms5") ? data.min_firms5 : null)
        : (has("min_firms3") ? data.min_firms3 : null);
      this.minFirmsRule = has("min_firms_rule") ? data.min_firms_rule : null;
      const blocked = want5 && data && data.ok5 !== undefined && Number(data.ok5) !== 1;
      this.fiveYearUnavailable = !!blocked;
      if (blocked) {
        this.isDisabled = true;
        this.loading = false;
      }
      return !blocked;
    },
    checkAvailability: async function() {
      // Each selection change starts a fresh availability check. Bump the generation so
      // any older in-flight poll loop below stops instead of firing more queue/check
      // requests for a job that has already completed and been consumed (that trailing
      // request 500s). beforeDestroy bumps it too, so leaving the page stops polling.
      this.availabilityPollGen = (this.availabilityPollGen || 0) + 1;
      const pollGen = this.availabilityPollGen;
      const pollStopped = () => this.availabilityPollGen !== pollGen;

      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : "0",
              industry: this.getData(this.industry),
              sales_class: this.getData(this.salesClass),
              area: this.getData(this.marketArea),
              years: this.$store.getters.years,
              type:
                this.$store.getters.type === "Industry firms" ? "if" : "spif",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit("SET_PROFILE_ID", id);
          this.updatePullTime({ isFinishedDate: false, productId: id });
        });
      if (
        this.industry != null &&
        this.marketArea != null &&
        this.salesClass != null
      ) {
        this.firmsAnalyzed = "";
        this.endYearAverage = "";
        this.isDisabled = true;
        this.loading = true;
        if (this.marketArea == "US [9999]" && this.isProfile) {

          // -------
          let totalTime = 0;
          let interval = 10000; // 10s timestep to avoid spamming the endpoint.
          let statusData = null;
          let keepRunning = true;

          await axios
            .get(process.env.VUE_APP_API_BASE_URL
              + '/queue/load/'+currentSession+'/if_legacy_avail/'
              + this.getData(this.industry) + '/0/' + this.getData(this.salesClass)
              + '/0/0/0/0'
              , {
              params: {session_id: currentSession},
            })
            .then((res) => {
              // If the job already finished (cached/synchronous completion), the load
              // response is the final status: skip polling entirely, since a queue/check
              // for an already-consumed job is a guaranteed 500.
              if (res && res.data && res.data.finished == true && res.data.data != null) {
                statusData = res;
              }
            }
          );

          while((statusData == null || statusData.data.finished == false) && keepRunning) {
            if(pollStopped()) { return; } // superseded by a newer check, or page left
            if(totalTime >= 600000) { throw new Error("Queue load timed out!"); break; } // 600s timeout (10min)
            if(statusData) { await sleep(interval); }
            if(pollStopped()) { return; } // re-check after sleeping, before firing another queue/check
            totalTime += interval;
            await axios.get(process.env.VUE_APP_API_BASE_URL
                + '/queue/check/'+currentSession+'/if_legacy_avail/'
                + this.getData(this.industry) + '/0/' + this.getData(this.salesClass)
                + '/0/0/0/0'
                , {
                params: {session_id: currentSession},
              })
              .then((res) => {
                statusData = res;
              }
            );
            if(statusData.data.data != null) { break; }
          }
          if(pollStopped()) { return; } // stale result: a newer check owns the UI now
          
          if(statusData.error) {
            //console.log("ERROR!!!");
            throw new Error(statusData.data.errorCode);
          }
          
          let res = null;
          const maxParseAttemptsLegacy = 3;
          for (let attempt = 1; attempt <= maxParseAttemptsLegacy; attempt++) {
            try {
              res = JSON.parse(JSON.parse(statusData.data.data));
              break;
            } catch (e) {
              // A response can arrive truncated if it was in flight when the
              // backend task got cycled out mid-stream. The job itself already
              // finished server-side, so re-checking should return the same
              // completed data intact; only give up after repeated truncation.
              if (attempt === maxParseAttemptsLegacy) { res = null; break; }
              if (pollStopped()) { return; }
              await sleep(3000);
              await axios.get(process.env.VUE_APP_API_BASE_URL
                  + '/queue/check/'+currentSession+'/if_legacy_avail/'
                  + this.getData(this.industry) + '/0/' + this.getData(this.salesClass)
                  + '/0/0/0/0'
                  , { params: {session_id: currentSession} })
                .then((r) => { statusData = r; });
            }
          }
          try {
            if (res == null) {
              this.isShowChecked = false;
            } else if ((res.hasOwnProperty("data") && res.data.error) || (res.hasOwnProperty("error") && res.error)) {
                let errorMessage = null;

                if(res.hasOwnProperty("data")) {
                  errorMessage = res.data.errorCode;
                } else {
                  errorMessage = res.errorCode;
                }

                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    errorMessage +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} +'/info/IF_legacy_available' <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    errorMessage
                );
              } else if (res.available) {
              this.isShowChecked = true;
              this.textLegacyAccessPrice = ` Add legacy year(s) ${res.yearsRange}:$${res.price}`;
              this.textLegacyAccess = `Add legacy year(s) ${res.yearsRange}`;
            } else {
              this.isShowChecked = false;
            }
          } catch (e) {
            //console.error(e); // error in the above string (in this case, yes)!
            //console.log(statusData.data.data);
          }
          // -------

          /*await axios
            .get(
              process.env.VUE_APP_API_BASE_URL + "/info/IF_legacy_available",
              {
                params: {
                  session_id: currentSession,
                  industry: this.getData(this.industry),
                  sales_class: this.getData(this.salesClass),
                },
              }
            )
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} +'/info/IF_legacy_available' <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              if (res.data.available) {
                this.isShowChecked = true;
                this.textLegacyAccessPrice = ` Add legacy year(s) ${res.data.yearsRange}:$${res.data.price}`;
                this.textLegacyAccess = `Add legacy year(s) ${res.data.yearsRange}`;
              } else this.isShowChecked = false;
            });*/

        } else {
          this.isShowChecked = false;
        }

        // -------
        if (this.$store.getters.type === "Sole proprietorship") {
          let endpoint = "/info/SPIF_available";
          let params = {
            industry: this.getData(this.industry),
          };

          await axios
          .get(process.env.VUE_APP_API_BASE_URL + endpoint, {
            params: params,
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IF_available" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const { data } = res.data;
            if (data != 0 && data != -1 && !(data && data.available === 0)) {
              this.firmsAnalyzed = data.firms;
              this.endYearAverage = data.sales;
              if (this.applyAvailabilityWindow(data)) { this.checkAccess(); }
            } else if (data == -1) {
              this.firmsAnalyzed = "";
              this.endYearAverage = "";
              this.isDisabled = true;
              this.notOffered = true;
              this.loading = false;
            } else {
              this.firmsAnalyzed = "";
              this.endYearAverage = "";
              this.isDisabled = true;
              this.notAvailable = true;
              this.loading = false;
            }
          });

        } else {
          let totalTime = 0;
          let interval = 10000; // 10s timestep to avoid spamming the endpoint.
          let statusData = null;
          let keepRunning = true;

          await axios
            .get(process.env.VUE_APP_API_BASE_URL
              + '/queue/load/'+currentSession+'/if_avail/'
              + this.getData(this.industry) + '/' + parseInt(this.getData(this.marketArea)) + '/' + this.getData(this.salesClass)
              + '/0/0/0/0'
              , {
              params: {session_id: currentSession},
            })
            .then((res) => {
              // If the job already finished (cached/synchronous completion), the load
              // response is the final status: skip polling entirely, since a queue/check
              // for an already-consumed job is a guaranteed 500.
              if (res && res.data && res.data.finished == true && res.data.data != null) {
                statusData = res;
              }
            }
          );

          while((statusData == null || statusData.data.finished == false) && keepRunning) {
            if(pollStopped()) { return; } // superseded by a newer check, or page left
            if(totalTime >= 600000) { throw new Error("Queue load timed out!"); break; } // 600s timeout (10min)
            if(statusData) { await sleep(interval); }
            if(pollStopped()) { return; } // re-check after sleeping, before firing another queue/check
            totalTime += interval;
            await axios.get(process.env.VUE_APP_API_BASE_URL
                + '/queue/check/'+currentSession+'/if_avail/'
                + this.getData(this.industry) + '/' + parseInt(this.getData(this.marketArea)) + '/' + this.getData(this.salesClass)
                + '/0/0/0/0'
                , {
                params: {session_id: currentSession},
              })
              .then((res) => {
                statusData = res;
              }
            );
            if(statusData.data.data != null) { break; }
          }
          if(pollStopped()) { return; } // stale result: a newer check owns the UI now
          
          if(statusData.error) {
            //console.log("ERROR!!!");
            throw new Error(statusData.data.errorCode);
          }
          
          let res = null;
          const maxParseAttemptsAvail = 3;
          for (let attempt = 1; attempt <= maxParseAttemptsAvail; attempt++) {
            try {
              res = JSON.parse(JSON.parse(statusData.data.data));
              break;
            } catch (e) {
              // A response can arrive truncated if it was in flight when the
              // backend task got cycled out mid-stream. The job itself already
              // finished server-side, so re-checking should return the same
              // completed data intact; only give up after repeated truncation.
              if (attempt === maxParseAttemptsAvail) { res = null; break; }
              if (pollStopped()) { return; }
              await sleep(3000);
              await axios.get(process.env.VUE_APP_API_BASE_URL
                  + '/queue/check/'+currentSession+'/if_avail/'
                  + this.getData(this.industry) + '/' + parseInt(this.getData(this.marketArea)) + '/' + this.getData(this.salesClass)
                  + '/0/0/0/0'
                  , { params: {session_id: currentSession} })
                .then((r) => { statusData = r; });
            }
          }
          try {
            if (res == null) {
              this.firmsAnalyzed = "";
              this.endYearAverage = "";
              this.isDisabled = true;
              this.notAvailable = true;
              this.loading = false;
            } else if ((res.hasOwnProperty("data") && res.data.error) || (res.hasOwnProperty("error") && res.error)) {
                let errorMessage = null;

                if(res.hasOwnProperty("data")) {
                  errorMessage = res.data.errorCode;
                } else {
                  errorMessage = res.errorCode;
                }

                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    errorMessage +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} +'/info/IF_available' <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    errorMessage
                );
            } else {
              const { data } = res;
              //console.log(data);
              if (data != 0 && data != -1 && !(data && data.available === 0)) {
                this.firmsAnalyzed = data.firms;
                this.endYearAverage = data.sales;
                if (this.applyAvailabilityWindow(data)) { this.checkAccess(); }
              } else if (data == -1) {
                this.firmsAnalyzed = "";
                this.endYearAverage = "";
                this.isDisabled = true;
                this.notOffered = true;
                this.loading = false;
              } else {
                this.firmsAnalyzed = "";
                this.endYearAverage = "";
                this.isDisabled = true;
                this.notAvailable = true;
                this.loading = false;
              }
            }
          } catch (e) {
            //console.error(e); // error in the above string (in this case, yes)!
            //console.log(statusData.data.data);
          }
        }
        // ---------

        /*let params = {
          industry: this.getData(this.industry),
          area: parseInt(this.getData(this.marketArea)),
          sales_class: this.getData(this.salesClass),
        };

        let endpoint = null;

        if (this.$store.getters.type === "Sole proprietorship") {
          endpoint = "/info/SPIF_available";
          params = {
            industry: this.getData(this.industry),
          };
        } else {
          endpoint = "/info/IF_available";
          params = {
            industry: this.getData(this.industry),
            area: parseInt(this.getData(this.marketArea)),
            sales_class: this.getData(this.salesClass),
          };
        }

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + endpoint, {
            params: params,
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IF_available" <br>`
              );
              throw new Error(
                "<br>" +
                  "Server responded with error = True <br> errorCode: " +
                  res.data.errorCode
              );
            }
            const { data } = res.data;
            if (data != 0 && data != -1 && !(data && data.available === 0)) {
              this.firmsAnalyzed = data.firms;
              this.endYearAverage = data.sales;
              if (this.applyAvailabilityWindow(data)) { this.checkAccess(); }
            } else if (data == -1) {
              this.firmsAnalyzed = "";
              this.endYearAverage = "";
              this.isDisabled = true;
              this.notOffered = true;
              this.loading = false;
            } else {
              this.firmsAnalyzed = "";
              this.endYearAverage = "";
              this.isDisabled = true;
              this.notAvailable = true;
              this.loading = false;
            }
          });*/
      } else {
        this.isDisabled = true;
        this.firmsAnalyzed = "";
        this.endYearAverage = "";
      }
    },
    clearAll: async function() {
      this.$store.commit("SET_PROFILE_ID", null);
      this.$store.commit("M_SET_PROFILE_ID", null);
    },
  },

  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      subscriptions: (state) => state.user.user_subscriptions ?? null,
    }),
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
    profileType() {
      return this.$store.getters.type;
    },
    profileId() {
      return this.$store.getters.profileId;
    },
    timeSeries() {
      return this.$store.getters.years;
    },
  },
  watch: {
    timeSeries(newValue, oldValue) {
      this.notAvailable = false;
      this.notOffered = false;
      this.fiveYearUnavailable = false;
      this.checkAvailability();
    },
    industry(newValue, oldValue) {
      this.notAvailable = false;
      this.notOffered = false;
      this.fiveYearUnavailable = false;
      this.checkAvailability();
    },
    marketArea(newValue, oldValue) {
      this.notAvailable = false;
      this.notOffered = false;
      this.fiveYearUnavailable = false;
      this.checkAvailability();
    },
    salesClass(newValue, oldValue) {
      this.notAvailable = false;
      this.notOffered = false;
      this.fiveYearUnavailable = false;
      this.checkAvailability();
    },
    profileType(newValue, oldValue) {
      this.notAvailable = false;
      this.notOffered = false;
      this.fiveYearUnavailable = false;
      this.checkAvailability();
    },
    subscriptions() {
      if (this.subscriptions && this.subscriptions.length > 0)
        this.checkAccessByType();
    },
  },
  async created() {
    if (this.$route.name === "NewProfile") {
      this.route = "/user/search_profiles/if";
      this.isProfile = true;
    } else {
      this.route = "/user/search_reports/if";
      this.isProfile = false;
    }

    /* this.$store.commit('SET_MARKET_AREA', 'US [9999]'),
     this.$store.commit('SET_SALES_CLASS', 'Industrywide [1]'),*/
    await this.clearAll();
  },
  mounted() {
    if (this.$route.name === "NewProfile")
      trackSelectorViewed(this.$route.query["data-id"] ? "financial_report" : "ifp", "classic");
  },
  beforeDestroy() {
    // Stop any in-flight availability poll loop (see checkAvailability) so no
    // trailing queue/check fires after the user has left the page.
    this.availabilityPollGen = (this.availabilityPollGen || 0) + 1;
  },
};
</script>
<style lang="scss">
.new-profile {
  margin-top: 20px;
}

.profile-left-sec {
  padding: 10px;
  padding-left: 30px !important;
}

@media only screen and (max-width: 600px) {
  .fin-pro-card {
    margin-bottom: 10px;
  }

  .profile-left-sec {
    margin-bottom: 10px;
  }

  .fin-tab-list {
    margin-top: 350px;
  }

  #finantialProfileTabs .md-tabs-navigation {
    padding-left: 15px;
  }
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .fin-tab-list {
    margin-top: 150px;
  }
}

.alert {
  padding: 20px;
  background-color: #6839dd;
  /* Red */
  color: white;
  margin-bottom: 15px;
  font-weight: bold;
}

.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: black;
}

.product-price {
  color: #3b7ef1;
  font-weight: 500;
}

.product-price-label {
  margin-top: 30px;
}

.product-price-label .title {
  margin-bottom: 0px;
}

.new-profile .toolbar-card .md-card-content .info-wrap {
  color: #002277 !important;
}
</style>
